import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
dayjs.extend(utcPlugin);
var convertByOffset = function (utcISODate, offset) {
    try {
        var date = dayjs.utc(utcISODate);
        if (typeof offset === 'number') {
            return date.utcOffset(offset).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
        }
        return utcISODate;
    }
    catch (err) {
        return utcISODate;
    }
};
export default convertByOffset;
